<div class="view-selector-wrapper" [class.open]="isOpen" [class.renaming-active]="renamingViewId"
  (clickOutside)="onOutsideClick()" [exclude]="'.dropdown-trigger, .mat-menu-panel, .mat-mdc-menu-panel'">
  <button type="button" class="dropdown-trigger" [class.open]="isOpen" (click)="toggleDropdown()" #trigger>
    @if (isTemporaryView) {
      <i class="material-icons trigger-icon temporary-view-icon">schedule</i>
      <span class="temporary-view-label">{{ 'Temporary View' | translate }}</span>
    } @else {
      <i class="material-icons trigger-icon">{{ selectedView?.isShared ? 'group' : 'person' }}</i>
      <span class="trigger-name">{{ currentViewName || selectedView?.name || ('Select view' | translate) }}</span>
      @if (selectedView && isDefault(selectedView)) {
        <span class="badge default">{{ 'Default' | translate }}</span>
      }
      @if (selectedView && orgDefaultViewId && selectedView.id === orgDefaultViewId) {
        <span class="badge default">{{ 'Org default' | translate }}</span>
      }
    }
    <i class="material-icons toggle-icon">{{ isOpen ? 'expand_less' : 'expand_more' }}</i>
  </button>

  @if (isOpen) {
    <div class="dropdown-panel" (click)="$event.stopPropagation()">
      @if (isLoading) {
        <div class="panel-loading">
          <app-rings-loader></app-rings-loader>
        </div>
      } @else {
        <div class="dropdown-header">
          @if (views.length > 0) {
            <app-list-filter-toolbar searchPlaceholder="Search views..."
            [resetTrigger]="filterResetTick" (filterChange)="onFilterChange($event)">
              @if (showUseMyDefault) {
                <button type="button" class="use-my-default-chip" [class.active]="useMyDefault"
                  [disabled]="!canToggleUseMyDefault" [attr.aria-pressed]="useMyDefault"
                  (click)="useMyDefaultChange.emit(!useMyDefault)">
                  <span class="check-box">
                    @if (useMyDefault) {
                      <i class="material-icons">check</i>
                    }
                  </span>
                  <span class="label">{{ 'Use my default' | translate }}</span>
                </button>
              }
            </app-list-filter-toolbar>
          }
        </div>
        <div class="views-list">
          @if (filteredViews.length === 0) {
            <div class="empty-state">
              <span>{{ 'No views found' | translate }}</span>
            </div>
          }
          @for (view of filteredViews; track trackByViewId($index, view)) {
            <div class="view-option"
              [class.selected]="view.id === selectedView?.id" [class.renaming]="view.id === renamingViewId"
              (click)="selectView(view)">
              @if (renamingViewId !== view.id) {
                <i class="material-icons view-icon">{{ view.isShared ? 'group' : 'person' }}</i>
                <span class="view-name">{{ view.name }}</span>
                @if (isDefault(view)) {
                  <span class="badge default">{{ 'Default' | translate }}</span>
                }
                @if (view.id === orgDefaultViewId) {
                  <span class="badge default">{{ 'Org default' | translate }}</span>
                }
                <button type="button" class="menu-trigger" [matMenuTriggerFor]="viewMenu"
                  (click)="openMenuFor(view, $event)" [title]="'Options' | translate">
                  <i class="material-icons">more_vert</i>
                </button>
              } @else {
                <div class="rename-container">
                  <input type="text" class="rename-input" [(ngModel)]="renameInput"
                    (keyup.enter)="confirmRename(view)" (keyup.escape)="cancelRenaming()"
                    (click)="$event.stopPropagation()" autofocus />
                    <button type="button" class="rename-btn confirm" (click)="confirmRename(view); $event.stopPropagation()"
                      [title]="'Save' | translate"><i class="material-icons">check</i></button>
                      <button type="button" class="rename-btn cancel" (click)="cancelRenaming(); $event.stopPropagation()"
                        [title]="'Cancel' | translate"><i class="material-icons">close</i></button>
                      </div>
                    }
                  </div>
                }
              </div>
              <ng-container *objectHasPermission="permissionObject; action: GridPermissions.Create">
                <div class="dropdown-footer">
                  @if (canSaveView) {
                    <div class="add-view-option" (click)="triggerAddView()">
                      <i class="material-icons">add</i>
                      <span>{{ addViewLabel | translate }}</span>
                    </div>
                  }
                  @if (!canSaveView) {
                    <div class="add-view-option disabled" [title]="cannotSaveViewTooltip | translate">
                      <i class="material-icons">add</i>
                      <span>{{ addViewLabel | translate }}</span>
                    </div>
                  }
                </div>
              </ng-container>
            }
          </div>
        }
      </div>

      <mat-menu #viewMenu="matMenu" [class]="'view-options-menu'" (menuClosed)="closeMenu()">
        <button type="button" class="view-options-item" (click)="startRenaming(menuView!)"
          [disabled]="menuView?.canManage === false">
          <i class="material-icons">edit</i>
          <span>{{ 'Rename' | translate }}</span>
        </button>
        <ng-container *objectHasPermission="permissionObject; action: GridPermissions.Create">
          <button type="button" class="view-options-item" (click)="duplicateView(menuView!)">
            <i class="material-icons">content_copy</i>
            <span>{{ 'Duplicate' | translate }}</span>
          </button>
        </ng-container>
        <button type="button" class="view-options-item" (click)="makeDefaultView(menuView!)"
          [disabled]="menuView?.id === defaultViewId">
          <i class="material-icons">star</i>
          <span>{{ 'Make Default' | translate }}</span>
        </button>
        <button type="button" class="view-options-item danger" (click)="deleteView(menuView!)"
          [disabled]="menuView?.id === defaultViewId || menuView?.canManage === false">
          <i class="material-icons">delete</i>
          <span>{{ 'Delete' | translate }}</span>
        </button>
      </mat-menu>
